import { fetcher } from 'services/helpers/responseHandler'

const get = async ({ month, year }) =>
  await fetcher.get('invitehistory/load', {
    month,
    year
  })

const uploadLogsApi = {
  get
}

export default uploadLogsApi
